module.exports = __webpack_public_path__ + "assets/img/branner_v3.572510d0.png";